export { default as PromoterBusinessCardQuery } from './PromoterBusinessCardQuery';
export { default as PromoterBannersQuery } from './PromoterBannersQuery';